import GuidLookupModelBase from '../_generated/modelBases/guid-lookup-model-base';

export default class GuidLookupModel extends GuidLookupModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
